// extracted by mini-css-extract-plugin
module.exports = {"container":"definition_container__n2X0z","tooltip":"definition_tooltip__hxO33"};